// NPM Imports
import React, { useContext } from 'react'
// Quote Context
// Component Imports
// JS Imports
// Asset Imports
import { useQuoteContext } from '../../../hooks/useQuoteContext'

export default function OneTimeDiscountsHeaderRow({ order = -99 }) {
   const state = useQuoteContext()
   const { getString } = state

   return (
      <div className='row' style={{ order: order }}>
         <h5 className='col-bhr1'>
            {getString('product.OneTimeDiscountsHeaderRow.Header.Title')}
         </h5>
         <h5 className='col'></h5>
         <h5 className='col'>{getString('global.Amount')}</h5>
      </div>
   )
}
